import { RequestTypeDisplayTextMap } from '@strata/react-chat';
import { CheckboxListFormik } from '@strata/react-checkbox-list';
import { type NotificationSettingsSchema } from '@strata/react-dialog';
import { useFormikContext } from 'formik';

import { NotificationTypes } from 'components/notifications/NotificationComponentMap';
import { ReadPermissionRequestTypeMap } from 'services/constants';
import { useAppSelector } from 'store';
import { type PayerRequestSummaryPreferences } from 'store/api/notificationApi';

const PayerRequestSummaryCategoryOptions = (permissions: string[]) =>
    Object.entries(ReadPermissionRequestTypeMap)
        .filter(([permission]) => permissions.includes(permission))
        .map(([_, value]) => ({ value, text: `${RequestTypeDisplayTextMap[value]} Requests` }));

export type PayerRequestSummaryNotificationSchema = {
    payerRequestSummaryTypes?: string[];
} & NotificationSettingsSchema;

export const PayerRequestSummarySettings = () => {
    const formik = useFormikContext<PayerRequestSummaryNotificationSchema>();
    const { permissions } = useAppSelector((state) => state.auth);

    const options = PayerRequestSummaryCategoryOptions(permissions);

    return options.length > 1 ? (
        <div className="padding__bottom--medium">
            <CheckboxListFormik
                name="payerRequestSummaryTypes"
                options={options}
                disabled={
                    formik.values.email?.includes(NotificationTypes.PAYREQSUM_COMPASS) === false
                }
                onChange={(values) => {
                    void (async () => {
                        await formik.setFieldValue('payerRequestSummaryTypes', values);
                        if (values.length === 0) {
                            await formik.setFieldValue(
                                'email',
                                formik.values.email?.filter(
                                    (item) => item !== NotificationTypes.PAYREQSUM_COMPASS,
                                ),
                            );
                        }
                    })();
                }}
                inline
            />
        </div>
    ) : null;
};

PayerRequestSummarySettings.Options = PayerRequestSummaryCategoryOptions;

PayerRequestSummarySettings.initialValues = (preferences?: PayerRequestSummaryPreferences) => ({
    payerRequestSummaryTypes:
        preferences?.payer_request_types?.find(
            (item) => item.code === NotificationTypes.PAYREQSUM_COMPASS,
        )?.types ?? [],
});

PayerRequestSummarySettings.submitValues = (
    values: PayerRequestSummaryNotificationSchema,
): PayerRequestSummaryPreferences => ({
    payer_request_types: [
        {
            code: NotificationTypes.PAYREQSUM_COMPASS,
            types: values.payerRequestSummaryTypes,
        },
    ],
});
